import { render, staticRenderFns } from "./RelatedPromosGames.vue?vue&type=template&id=53eeeb46&"
import script from "./RelatedPromosGames.vue?vue&type=script&lang=js&"
export * from "./RelatedPromosGames.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports